import { useRef } from 'react';
import { CurrencyInput } from 'src/chakra-components/Input/CurrencyInput';
import { OrderSource } from 'src/entities/Order';

const Taxes = ({ ICMSST, orderSource }) => {
  const salesControlSources = [
    OrderSource.VENDORS_PORTAL,
    OrderSource.SALES_APP,
  ];
  const nfRef = useRef();

  return (
    <>
      <div className="row border-top pt-4">
        <div className="col-12">
          <h1 className="title-section mt-2 mb-0 fw-light" ref={nfRef}>
            Impostos e taxas
          </h1>
          <p className="text-secondary fs-5">Valor dos impostos deste pedido</p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-12 col-md-4">
          <p className="fw-bold mt-1 pb-1 pt-md-2 mb-0">
            Valor do ICMS-ST + valor do FCP-ST
          </p>
        </div>
        <div className="col-12 col-md-4">
          <CurrencyInput isReadOnly isDisabled height="50px" value={ICMSST} />
          {salesControlSources.includes(orderSource) && (
            <p className="text-secondary">
              Não é possível editar, pois o valor de ICMS-ST está incluso no
              valor total do pedido.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default Taxes;
